/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
if (!window.Utility) { window.Utility = {}; }

Utility.TrixUploads = class TrixUploads {
  static prepare() {
    let uploadNoteAttachment;
    let createStorageKey = undefined;
    let uploadAttachment = undefined;

    Trix.config.attachments.preview.caption = {
      name: false,
      size: false
    };

    document.addEventListener("trix-file-accept", (event) => {
      if (($(event.target).data('note-attachment') !== undefined) && ($(event.target).data('note-id') === "")) {
        $.jGrowl("Please save note before adding attachment.", {position: 'center', theme: 'error'});
        return event.preventDefault();
      }
    });

    document.addEventListener("trix-action-invoke", function(event) {
      if (event.actionName === "x-embed") {
        const {
          editor
        } = event.target;
        const range = editor.getSelectedRange();
        const src = editor.getDocument().toString().substring(range[0], range[1]).trim();
        if (src.substring(0,5) === 'https') {
          return imageExists(src, function(exists) {
            if (exists) {
              const embed = '<img src="' + src + '"">';
              const attachment = new Trix.Attachment({
                content: embed});
              return event.target.editor.insertAttachment(attachment);
            }
          });
        }
      }
    });

    document.addEventListener('trix-attachment-remove', function(event) {
      const {
        attachment
      } = event;
      // console.log attachment

      if (attachment.attachment.attributes.values.noteAttachmentId !== undefined) {
        return deleteNoteAttachment(attachment);
      }
    });

    document.addEventListener('trix-attachment-add', function(event) {
      const {
        attachment
      } = event;
      console.log(attachment.file);
      if (attachment.file) {
        $("input[type='submit']").prop('disabled', true);
        if ($(event.target).data('note-attachment') !== undefined) {
          return uploadNoteAttachment(attachment, attachment.file.type !== "application/pdf");
        } else {
          return uploadAttachment(attachment, attachment.file.type !== "application/pdf", $(event.target).data('note-id'));
        }
      }
    });

    var imageExists = function(url, callback) {
      const img = new Image;
      img.onload = function() {
        callback(true);
      };
      img.onerror = function() {
        callback(false);
      };
      img.src = url;
    };

    var deleteNoteAttachment = n => $.ajax({
      type: 'DELETE',
      url: '/note_attachments/' + n.attachment.attributes.values.noteAttachmentId,
      cache: false,
      contentType: false,
      processData: false,
      error(response, status) {
        return alert("Attachment not found.");
      }
    });

    createStorageKey = function(file) {
      let date = undefined;
      let day = undefined;
      let time = undefined;
      date = new Date;
      day = date.toISOString().slice(0, 10);
      time = date.getTime();
      return 'tmp/' + day + '/' + time + '-' + file.name;
    };

    uploadAttachment = function(attachment, isImage) {
      let file = undefined;
      let form = undefined;
      let key = undefined;
      let xhr = undefined;

      ({
        file
      } = attachment);
      key = createStorageKey(file);

      return $.ajax({
        dataType: 'json',
        url: "/attachments/new/",
        cache: false,
        success(result) {
          form = new FormData;
          form.append('key', result.key);
          form.append('acl', result.acl);
          form.append('success_action_status', result.success_action_status);
          form.append('policy', result.policy);
          form.append('x-amz-algorithm', result['x-amz-algorithm']);
          form.append('x-amz-credential', result['x-amz-credential']);
          form.append('x-amz-date', result['x-amz-date']);
          form.append('x-amz-signature', result['x-amz-signature']);
          form.append('file', file);

          xhr = new XMLHttpRequest;
          xhr.open('POST', result.url, true);

          xhr.upload.onprogress = function(event) {
            let progress = undefined;
            progress = (event.loaded / event.total) * 100;
            return attachment.setUploadProgress(progress);
          };

          xhr.onload = function() {
            if (xhr.status === 201) {
              let href;
              const response = $(xhr.responseText);
              // console.log response
              const location = response.find('Location').text();
              key = response.find('Key').text();

              const url = (href = location);
              $("input[type='submit']").prop('disabled', false);

              $.ajax({
                url: "/attachments/",
                type: 'POST',
                data: {attachment: {document_key: key}},
                cache: false,
                dataType: 'script'
              });

              if (isImage) {
                return attachment.setAttributes({
                  url});
              } else {
                return attachment.setAttributes({
                  url,
                  href
                });
              }
            }
          };

          return xhr.send(form);
        },

        error(response, status) {
          return alert("Unable to upload.");
        }
      });
    };

    return uploadNoteAttachment = function(attachment, isImage, noteId) {
      const {
        file
      } = attachment;
      const form = new FormData($('#new_note_attachment')[0]);
      form.append('note_attachment[file]', file);

      const xhr = new XMLHttpRequest;
      xhr.open('POST', "/note_attachments", true);

      xhr.upload.onprogress = function(event) {
        let progress = undefined;
        progress = (event.loaded / event.total) * 100;
        return attachment.setUploadProgress(progress);
      };

      xhr.onload = function() {
        if (xhr.status === 200) {
          let href;
          const response = JSON.parse(xhr.responseText);
          // console.log response
          const {
            location
          } = response;
          const url = (href = location);

          $("input[type='submit']").prop('disabled', false);
          $.jGrowl("Note Attachment saved.", {position: 'center', theme: 'success'});
          if (isImage) {
            return attachment.setAttributes({
              url,
              noteAttachmentId: response.id
            });
          } else {
            return attachment.setAttributes({
              url,
              href,
              noteAttachmentId: response.id
            });
          }
        } else {
          $.jGrowl("Unable to create Note Attachment.", {position: 'center', theme: 'error'});
          return;
        }
      };
      return xhr.send(form);
    };
  }
};
